import moment from "moment-timezone";
import { getStorageData } from "@/utils/storage";

const STORAGE_SYSTEM_KEY = "system";

const mixins = {
  moment: function() {
    let timezone = "UTC";
    const user = getStorageData("user") || {};

    if (user.timezone) {
      timezone = user.timezone;
    }

    moment.tz.setDefault(timezone);
    // eslint-disable-next-line no-undef
    return moment(...arguments);
  },
  getRevision: function() {
    const system = getStorageData(STORAGE_SYSTEM_KEY);

    const revision = process.env.VUE_APP_REVISION;

    if (!system || !system.revision) {
      return revision;
    }

    return system.revision || revision;
  }
};

export default mixins;
